import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { BrowserModule } from '@angular/platform-browser';
//import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
// used to create fake backend
import { fakeBackendProvider } from './_helpers';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './_components';
import { ErrorComponent } from './_components/error/error.component';
import { TrimbleErrorComponent } from './_components/error/trimble.error.component';
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { MatElementsModule } from './_modules/mat-elements.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { FeeDetailsComponent } from './fee-details/fee-details.component';
import { FormatDataComponent } from './format-data/format-data.component';
import { LoginComponent } from './login/login.component';
import { MbenzFeeDetailsComponent } from './mbenz-fee-details/mbenz-fee-details.component';
import { QrFeeDetailsComponent } from './qr-fee-details/qr-fee-details.component';
import { TrimbleFeeDetailsComponent } from './trimble-fee-details/trimble-fee-details.component';
import {FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

import { MatDividerModule } from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';

import {MatDatepickerInput, MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    MatElementsModule,
    BrowserAnimationsModule,
    MatGridListModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatGridListModule,
    MatRadioModule,
    FormsModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatTabsModule,
    MatCheckboxModule
    //   SweetAlert2Module.forRoot()
  ],
  declarations: [
    AppComponent,
    AlertComponent,
    ErrorComponent,
    FeeDetailsComponent,
    TrimbleFeeDetailsComponent,
    TrimbleErrorComponent,
    QrFeeDetailsComponent,
    MbenzFeeDetailsComponent,
    LoginComponent,
    DashboardComponent,
    FormatDataComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    fakeBackendProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
